import type {SVGProps} from 'react'

const SvgGasLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 48 48'}
    {...props}
  >
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M0 14a4.6 4.6 0 0 1 4.6-4.6h10a4.6 4.6 0 0 1 4.6 4.6v24.6H0zm4.6-3.4A3.4 3.4 0 0 0 1.2 14v23.4H18V14a3.4 3.4 0 0 0-3.4-3.4z'}
      clipRule={'evenodd'}
    />
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M22.6 38.6H.6v-1.2h22zM12.6 18.6h-6v-1.2h6zM22.152 12.764l2.838 6.622a2.6 2.6 0 0 1 .21 1.024V30.5a2.1 2.1 0 1 1-4.2 0V26h1.2v4.5a.9.9 0 1 0 1.8 0V20.41a1.4 1.4 0 0 0-.113-.55l-2.838-6.624z'}
      clipRule={'evenodd'}
    />
  </svg>
)
export default SvgGasLarge
